module.exports = __webpack_public_path__ + "media/10_1.ddf01048.wav";